module.exports = __webpack_public_path__ + "img/8.44071780.jpg";